/* eslint-disable  */
import React, { useState, useEffect } from "react";
import { TextField, Button, Modal } from "@mui/material";
// import Dashboard from "./Dashboard";
import axios from "axios";
// import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
import { Container, Stack, SvgIcon } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import { get, post, put } from "../library/Api";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import EditIcon from "@mui/icons-material/Edit";
import { remove } from "../library/Api";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { toast, ToastContainer } from "react-toastify";
import { Modal as antmodel } from "antd";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import deleteIcon from '../assets/images/delete.svg';
import editIcon from '../assets/images/edit.svg';
import downloadIcon from '../assets/images/import.svg';
import { padding } from "@mui/system";
import PulseLoader from "react-spinners/PulseLoader";
import { Modal as AntdModal } from "antd";
// import { Modal} from "antd";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const columns = [
  {
    name: "Company",
    selector: "company",
  },
];

const conformation_modal_style ={
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 460,
  bgcolor: 'background.paper',
  border: '2px solid #ffff',
  boxShadow: 24,
  padding: '55px 30px !important'
}



const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  padding: "55px 30px",
  borderRadius: "10px",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  // p: 4,
};

export function UserForm() {
  const [age, setAge] = React.useState("");

  const handleChangeSelect = (event) => {
    setAge(event.target.value);
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setShow(false);
    setShows(false);
  };

  const [datas, setDatas] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [companyLists, setCompanyLists] = useState([]);
  const [List, setList] = useState([]);
  const [historyList, setHistoryList] = useState([]);
  const [company, setCompany] = useState("");
  const [companys, setCompanys] = useState("");
  const [companysold, setCompanysold] = useState("");
  const [username, setusername] = useState("");
  const [userpassword, setuserpassword] = useState("");
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [usernames, setusernames] = useState("");
  const [companyedit, setCompanyedit] = useState("");
  const [companyeditid, setCompanyeditid] = useState("");
  const [userpasswords, setuserpasswords] = useState("");
  const [firstNames, setfirstNames] = useState("");
  const [lastNames, setlastNames] = useState("");
  const [editid, SetEditid] = useState("");
  const [show, setShow] = useState(false);
  const [shows, setShows] = useState(false);
  const [open, setOpen] = useState(false);
  const [opens, setOpens] = useState(false);
  const [openeditadmin, setOpeneditadmin] = useState(false);
  const [openeditcompany, setOpeneditcompany] = useState(false);
  const[ShowadminDelete,setShowadminDelete] = useState(false);
  const [csv_importid,setCsv_importid] =  useState("");
  const [emailLists, setEmailList] = useState([]);
  const [openAddEmailModal,setOpenAddEmailModal] = useState(false);
  const [openEditEmailModal,setOpenEditEmailModal] = useState(false);
  const [opendeleteConformation, setopendeleteConformation] = useState(false);
  const [selectedEmailFid, setSelectedEmailFid] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [sendType, setSendType] = useState("");
  const [admin_id, setadmin_id] = useState('');
  const [fid, setFid] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [filteredEmails, setFilteredEmails] = useState([]);
  const [emailDataForFiltering,setEmailDataForFiltering] = useState([])
  const [emailError, setEmailError] = useState('');
  const [opendeleteAdminConformation, setopendeleteAdminConformation] = useState(false);
  const [selectedAdmin_id, setSelectedAdmin_id] = useState(null);
  const [triggerReload, settriggerReload] = useState(false);
  const [showcompanyDeleteModel, setshowcompanyDeleteModel] = useState(false);
  const [SelectedCompanyid,setSelectedCompanyid] = useState('');
  const [selectedCompany_nameDelete,setselectedCompany_nameDelete] = useState('')
  const location = useLocation();
  const navigate = useNavigate();
  const myNewTheme = {
    rows: {
      fontSize: "50px",
    },
  };

  const HandleClicks = () => {
    setOpens(true);
  };

  const HandleAddEmailClick = () =>{
    setOpenAddEmailModal(true)
    setSendType("")
    setEmail("")
  }

  const handleEmailModalCloses = ()=>{
    setOpenAddEmailModal(false)

  }

  const handleEmailEditModalCloses = ()=>{
    setOpenEditEmailModal(false)
  }

  const HandleClick = () => {
    setOpen(true);
    setCompany("");
  };

  const convert_to_localtime = (gmt) => {
    const gmtTime = new Date(String(gmt));
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const userTimeFormat = new Intl.DateTimeFormat('en-US', {
      timeZone: userTimezone,
      year: 'numeric',
      month: 'long',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
    
    const localTime = userTimeFormat.format(gmtTime);
    return localTime;
  }

  const handleClose = () => {
    // if (location.pathname === "/vehicle") {
    //   navigate("/registers");
    // } else {
    //   navigate("/registers");
    // }
    setOpen(false);
  };



  const handleCloseeditcompany = () => {
    // if (location.pathname === "/vehicle") {
    //   navigate("/registers");
    // } else {
    //   navigate("/registers");
    // }
    setOpeneditcompany(false);
  };
  const handleCloseeditadmin = () => {
    // if (location.pathname === "/vehicle") {
    //   navigate("/registers");
    // } else {
    //   navigate("/registers");
    // }
    setOpeneditadmin(false);
  };
  
  const handlecancelAdmindelete = () =>{
    setShowadminDelete(false)
  }

  const handlecancelCompanyDelete = () =>{
    setshowcompanyDeleteModel(false)
  }

  const handleDeletecompanyClickPopup = (companyid,company_name) =>{
    let company_id = companyid;
    let companyname = company_name;
    setSelectedCompanyid(company_id)
    setselectedCompany_nameDelete(companyname)
    setshowcompanyDeleteModel(true)
  }
  const handleDeletecompany = () =>{
    let company_id = SelectedCompanyid
    let ur = "delete_companynames/".concat(String(company_id))
    
    console.log(ur)
    remove(ur).then((response) => {
      if (response.status == 200) {
        console.log("response", response);
        // alert("Deleted", row.customer_id);
        toast.error(response.data.message, {
          autoClose: 500,
        });
        window.location.reload();
      } else {
        toast.error(`Error `, {
          autoClose: 500,
        });
      }
      // setTimeout(() => {
        settriggerReload(!triggerReload)
      // }, 2000);
    });

  }



  const handleDownloadClick = (importid) =>{
    console.log("--------------adm",importid)
    const import_ids = importid
    setCsv_importid(import_ids)

  }


  const OpenAdminConformationDelete = (adminid)=>{
    setopendeleteAdminConformation(true)
	  setSelectedAdmin_id(adminid)
  }

  const CloseAdminConformationDelete = ()=>{
    setopendeleteAdminConformation(false)
	  setSelectedAdmin_id(null)
  }

  const handleDeleteAdmin = (adminid) => {

    // setShowadminDelete(true)
    //
    let admin_id = adminid
    let ur = "delete_admin/".concat(String(admin_id))
    console.log(ur)
      
    remove(ur).then((response) => {
      if (response.status == 200) {
        console.log("response", response);
        // alert("Deleted", row.customer_id);
        toast.error(response.data.message, {
          autoClose: 500,
        });
        // window.location.reload();
        settriggerReload(!triggerReload)
      } else {
        toast.error(`Error `, {
          autoClose: 500,
        });
      }
      // setTimeout(() => {

      // }, 2000);
    });

    //

  }

  // Sorting function to order by "Send Type"
const sortBySendType = (data) => {
  const order = ["to", "cc", "bcc"];
  return data.sort((a, b) => order.indexOf(a.sent_type) - order.indexOf(b.sent_type));
};

  const handleFilterChange = (event) => {
    const filter =event.target.value;
    setSelectedFilter(filter);
    console.log("filter at first loading::::::::",filter)
    if (filter === "all") {
      // setEmailDataForFiltering(emailLists); // Show all emails
      setEmailDataForFiltering(sortBySendType(emailLists)); // Show all emails
      
    } else {
      const filtered = emailLists.filter(email => email.sent_type === filter);
      setEmailDataForFiltering(filtered);
    }
  };


  const CloseDeleteConformation=()=>{
    setSelectedEmailFid(null);
    setopendeleteConformation(false);
  }

  const OpenConformationModal = (fid) =>{
    setSelectedEmailFid(fid);
    setopendeleteConformation(true);
  }

  const handleDeleteEmail = (fid) => {
    const email_delete_api = "delete_emailconfig";
  
    const data = {
      fid: fid
    };
  
    console.log("Delete Request Data:", data);
  
    post(email_delete_api, data)
      .then((response) => {
        if (response.status === 200) {
          console.log("Delete Response:", response);
          toast.error(response.data.message, {
            autoClose: 500,
          });
          // window.location.reload();
          settriggerReload(!triggerReload)
        } else {
          toast.error(`Error: ${response.statusText}`, {
            autoClose: 500,
          });
        }
      })
      .catch((error) => {
        console.error("Delete Error:", error);
        toast.error(`Error: ${error.message || error}`, {
          autoClose: 500,
        });
      });
  };
  
  

  const handleEditEmail =(emailConfig)=>{

    setEmail(emailConfig.email);
    setSendType(emailConfig.sent_type);
    setFid(emailConfig.fid);

    setOpenEditEmailModal(true);

  }

  const handleCloses = () => {
    // if (location.pathname === "/vehicle") {
    //   navigate("/registers");
    // } else {
    //   navigate("/registers");
    // }
    setOpens(false);
  };
  const handlecompany = (e) => {
    console.log(e);
    setCompany(e.target.value);
  };

  const handleEdit = (id) => {
    setOpeneditadmin(true);
    SetEditid(id);
    setfirstNames("");
    setlastNames("");
    setusernames("");
    setCompanyedit("");
    setCompany("");
    setuserpasswords("");
    get(`get_admin/${id}`).then((response) => {
      console.log("ccc", response.data);

      setfirstNames(response.data.first_name);
      setlastNames(response.data.last_name);
      setusernames(response.data.username);
      setCompanyedit(response.data.company);
      setCompanyeditid(response.data.company_id);
      setuserpasswords(response.data.userpassword);
    });
  };
  const handleEditcompany = (id) => {
    
    setOpeneditcompany(true);
    SetEditid(id);
    setCompanys("");
    get(`get_company/${id}`).then((response) => {
      console.log("ggggg", response.data.company);

      setCompanys(response.data.company.company_name);
      setCompanysold(response.data.company.company_name);
      settriggerReload(!triggerReload)
    });
  };
  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
    setShow(false);
  };

  const handleEmailChange = (event) => {
    // setEmail(event.target.value);

    const value = event.target.value;
    setEmail(value);

    // Simple email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (value === '') {
      setEmailError(''); // Clear error if field is empty
    } else if (!emailRegex.test(value)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
    }
  };
  
  const handleSendTypeChange = (event) => {
    setSendType(event.target.value);
  };


  const handleSubmitEditEmail = (event) =>{
    event.preventDefault();


    // Check if the email is valid or empty
    if (!email || emailError) {
      if (!email) {
        setEmailError('Please enter an email address');
      }
      return;
    }

    const data = {
      fid: fid, 
      email: email,
      sent_type: sendType,
    };

    post("update_emailconfig", data)
    .then((response) => {
      if (response.status === 200) {
        toast.success("Email configuration updated successfully", {
          autoClose: 500,
        });

        setOpenEditEmailModal(false);

        setTimeout(() => {
          // window.location.reload();
          settriggerReload(!triggerReload)
        }, 2000);
      } else {
        toast.error("Failed to update email configuration");
      }
    })
    .catch((error) => {
      console.error("Error during API call:", error);
      toast.error("An error occurred during the API call.");
    });
    
  }

  useEffect(() => {
    var mcdata = JSON.parse(localStorage.getItem("MCData"));
    var tempadmin_id= mcdata.admin_id
    setadmin_id(tempadmin_id)
  }, []);
  

  const handleSubmitEmail = (event) => {
   
    event.preventDefault();
    handleClose();
     // Check if the email is valid or empty
     if (!email || emailError) {
      if (!email) {
        setEmailError('Please enter an email address');
      }
      return;
    }
    setIsLoading(true)
    // Create the data object
    const data = {
      email: email, 
      sent_type: sendType,
      admin_id: admin_id
    };
  
    post("add_emailconfig", data).then((response) => {
      console.log("data", response.data.message);
      if (response.status === 200) {  
        console.log("success");
        toast.success(response.data.message, {
          autoClose: 500,
        });
        setOpenAddEmailModal(false);
        setIsLoading(false)
  
        setTimeout(() => {
          // window.location.reload();
          settriggerReload(!triggerReload)
        }, 2000);
      } else {
        toast.error(response.data.message);
        setIsLoading(false)

      }
    });
  };
  

  const handleSubmit = (event) => {
    event.preventDefault();

    const data = {
      username: username,
      userpassword: userpassword,
      company_id: company,
      firstName: firstName,
      lastName: lastName,
    };

    post("create_admin", data).then(
      (response) => {
        console.log("data", response.data.message);
        if (response.data.success == true) {
          toast.success(response.data.message, {
            autoClose: 500,
          });

          setTimeout(() => {
            window.location.reload();
          }, 2000);

          setusername("");
          setuserpassword("");
          setCompany("");
          setfirstName("");
          setlastName("");
        } else {
          toast.error(response.data.message);
        }
      },
      (error) => {
        //   toast.error(error.response.data.message, {
        //     autoClose: 3000,
        //   });
      }
    );
  };
  const handleSubmits = (event) => {
    event.preventDefault();
    setOpens(false);
    const data = {
      company: company,
    };

    post("create_company", data).then(
      (response) => {
        console.log("data", response.data.message);
        if (response.data.success == true) {
          toast.success(response.data.message, {
            autoClose: 500,
          });

          setTimeout(() => {
            // window.location.reload();
            settriggerReload(!triggerReload)
          }, 2000);

          setCompany("");
        } else {
          toast.error(response.data.message);
        }
      },
      (error) => {
        //   toast.error(error.response.data.message, {
        //     autoClose: 3000,
        //   });
      }
    );
  };

  const handleSubmiteditcompany = (event) => {
    event.preventDefault();

    const data = {
      company_name: companys,
      old_company_name: companysold,
    };

    put(`edit_companynames/${editid}`, data).then(
      (response) => {
        console.log("data", response.data.message);
        if (response.data.message) {
          toast.success(response.data.message, {
            autoClose: 500,
          });

          setTimeout(() => {
            window.location.reload();
          }, 2000);

          setCompanys("");
        } else {
          toast.error(`Failed to Edit Company`);
        }
      },
      (error) => {
        //   toast.error(error.response.data.message, {
        //     autoClose: 3000,
        //   });
      }
    );
  };

  const handleSubmiteditadmin = (event) => {
    event.preventDefault();
    if (!company) {
      setCompany(companyeditid);
    }

    const data = {
      company_id: company || companyeditid,
      username: usernames,
      firstName: firstNames,
      lastName: lastNames,
      userpassword: userpasswords,
    };

    put(`edit_admin/${editid}`, data).then(
      (response) => {
        console.log("data", response.data.message);
        if (response.data.message) {
          toast.success(response.data.message, {
            autoClose: 500,
          });
          // navigate("/user");
          
          setTimeout(() => {
            // window.location.reload();
            settriggerReload(!triggerReload)
          }, 2000);

          setCompanys("");
        } else {
          toast.error(`Failed to Edit Company`);
        }
      },
      (error) => {
        //   toast.error(error.response.data.message, {
        //     autoClose: 3000,
        //   });
      }
    );
  };

  useEffect(() => {
    get(`get_company_list`).then((res) => {
      // const data = res;
      setCompanyList(res?.data.companies);
      // console.log(res.data.companies[0])
    });
    get(`get_company_list_id`).then((res) => {
      // const data = res;
      setCompanyLists(res?.data.companies);
      // console.log(res.data.companies[0])
    });
    get(`get_admins_companies`).then((res) => {
      // const data = res;
      setList(res.data);
      console.log(res.data);
    });
 
    get(`get_import_history`).then((res) => {
      // const data = res;
      setHistoryList(res.data);
      console.log(res.data);
    });

  }, [triggerReload]);


  useEffect(() => {
    get(`list_customerdata`).then((res) => {
      const data = res;
      console.log(data.data);
      setDatas(data.data);
    });
  }, []);


  useEffect(() => {
    const url ='export_import_history/'.concat(String(csv_importid))
    if(csv_importid){
    get(url, {
      responseType: 'blob', // Set the response type to 'blob' for binary data
    }).then((fileResponse) => {
      console.log("----------fileResponse----------------------->>",fileResponse)
            if(fileResponse.status == '200'){
             const blob = new Blob([fileResponse.data], { type: 'application/csv' });
            // Create a temporary URL for the blob
            const url = window.URL.createObjectURL(blob);
            // Create a temporary anchor element to trigger the download
            const a = document.createElement('a');
            a.href = url;
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
            const date = currentDate.getDate().toString().padStart(2, '0');
            const hours = currentDate.getHours().toString().padStart(2, '0');
            const minutes = currentDate.getMinutes().toString().padStart(2, '0');
            // const seconds = currentDate.getSeconds().toString().padStart(2, '0');
            // Set the download file name with the formatted date
            const formattedDate = `${year}_${month}_${date}_${hours}_${minutes}`;
            const fileName = `Failed_csv_${formattedDate}.csv`;
            a.download = fileName 
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
           
            console.log("----------fileResponse----------------------->>",fileResponse)
            toast.info('Download completed Successfully',{
              autoClose: 1000,
            })
          }
        

    }).catch((error) => {
      toast.info(error.message,{
        autoClose: 3000,
      })
    });
  }
  }, [csv_importid]);

  useEffect(() => {
    setIsLoading(true)
    get(`list_emailconfig`)
      .then((res) => {
        // const data = res;
        
        setEmailList(res.data);
        const sortedData = sortBySendType(res.data);
        setEmailDataForFiltering(sortedData)
        setIsLoading(false)
        console.log("email conf data::::", res.data);
      })
      .catch((error) => {
        setIsLoading(false)
        console.error("ERROR", JSON.stringify(error, null, 2)); // Logs the error object as a string
        // Or you can log specific properties of the error
        console.error("ERROR DETAILS", error.message, error.response);
      });
  }, [triggerReload]);

  return (
    <>
      <ToastContainer />

        {ShowadminDelete? (
        <antmodel
            open={ShowadminDelete}
            title="Delete"
            // onOk={onConfirmButtonClick}
            onCancel={handlecancelAdmindelete}
            footer={[
              <Button key="back" onClick={handlecancelAdmindelete}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                // onClick={onConfirmButtonClick}
              >
                Delete
              </Button>,
            ]}
          >
            <p className="text-center">Are you sure you want to Delete ?</p>
          </antmodel>):("")}
    


          

      {open === true ? (

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            ></Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Admin First Name"
                value={firstName}
                onChange={(e) => setfirstName(e.target.value)}
                fullWidth
                required
                sx={{ mb: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Admin Last Name"
                value={lastName}
                onChange={(e) => setlastName(e.target.value)}
                fullWidth
                required
                sx={{ mb: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                type="email"
                variant="outlined"
                color="secondary"
                label="Email ID"
                value={username}
                onChange={(e) => setusername(e.target.value)}
                fullWidth
                required
                sx={{ mb: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                type="password"
                variant="outlined"
                color="secondary"
                label="Password"
                value={userpassword}
                onChange={(e) => setuserpassword(e.target.value)}
                fullWidth
                required
                sx={{ mb: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <Box sx={{ minWidth: 120 }} className="mb-4">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label"></InputLabel>

                  <TextField
                    fullWidth
                    select
                    label="Select Company"
                    name="name"
                    onChange={handlecompany}
                    required
                    value={company}
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{ native: true }}
                    sx={{ mb: 2 }}
                  >
                    <option key="" value="">
                      {" "}
                      Please select{" "}
                    </option>
                    {companyLists.map((company, index) => (
                      <option
                        key={company.company_id}
                        value={company.company_id}
                      >
                        {company.company_name}
                      </option>
                    ))}
                  </TextField>
                </FormControl>
              </Box>
              <div className="text-end">
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  className="me-4 btn-sty"
                >
                  Save
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleClose}
                  size="large"
                  className="btn-sty"
                >
                  Cancel
                </Button>
              </div>
            </form>
          </Box>
        </Modal>
      ) : (
        ""
      )}
      {openeditadmin === true ? (
        <Modal
          open={openeditadmin}
          onClose={handleCloseeditadmin}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            ></Typography>
            <form onSubmit={handleSubmiteditadmin}>
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Admin First Name"
                value={firstNames}
                onChange={(e) => setfirstNames(e.target.value)}
                fullWidth
                required
                sx={{ mb: 2 }}
              />
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Admin Last Name"
                value={lastNames}
                onChange={(e) => setlastNames(e.target.value)}
                fullWidth
                required
                sx={{ mb: 2 }}
              />
              <TextField
                type="email"
                variant="outlined"
                color="secondary"
                label="Email ID"
                value={usernames}
                onChange={(e) => setusernames(e.target.value)}
                fullWidth
                required
                sx={{ mb: 2 }}
              />
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Password"
                value={userpasswords}
                onChange={(e) => setuserpasswords(e.target.value)}
                fullWidth
                required
                sx={{ mb: 2 }}
              />
              <Box sx={{ minWidth: 120 }} className="mb-4">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label"></InputLabel>

                  <TextField
                    fullWidth
                    select
                    label="Select Company"
                    name="name"
                    onChange={handlecompany}
                    value={company}
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{ native: true }}
                    sx={{ mb: 2 }}
                  >
                    <option key="" value="">
                      {" "}
                      {companyedit}{" "}
                    </option>
                    {companyLists.map((company, index) => (
                      <option
                        key={company.company_id}
                        value={company.company_id}
                      >
                        {company.company_name}
                      </option>
                    ))}
                  </TextField>
                </FormControl>
              </Box>
              <div className="text-end mt-3">
                {editid?<Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  className="me-4 btn-sty"
                >
                  Update
                </Button>:<Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  className="me-4 btn-sty"
                >
                  Save
                </Button>}
                {/* <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  className="me-4 btn-sty"
                >
                  Save
                </Button> */}
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleCloseeditadmin}
                  size="large"
                  className="btn-sty"
                >
                  Cancel
                </Button>
              </div>
            </form>
          </Box>
        </Modal>
      ) : (
        ""
      )}
      {opens === true ? (
        <Modal
          open={opens}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            ></Typography>
            <form onSubmit={handleSubmits}>
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                fullWidth
                required
                sx={{ mb: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <div className="text-end mt-2">
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  className="me-4 btn-sty"
                >
                  Save
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleCloses}
                  size="large"
                  className="btn-sty"
                >
                  Cancel
                </Button>
              </div>
            </form>
          </Box>
        </Modal>
      ) : (
        ""
      )}
      {openeditcompany === true ? (
        <Modal
          open={openeditcompany}
          onClose={handleCloseeditcompany}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            ></Typography>
            <form onSubmit={handleSubmiteditcompany}>
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Company"
                value={companys}
                onChange={(e) => setCompanys(e.target.value)}
                fullWidth
                required
                sx={{ mb: 2 }}
              />

              <div className="text-end mt-3">
                {editid? <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  className="me-4 btn-sty"
                >
                  Update
                </Button>:
                <Button
                variant="contained"
                color="primary"
                type="submit"
                size="large"
                className="me-4 btn-sty"
              >
                Save
              </Button>
                }
                
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleCloseeditcompany}
                  size="large"
                  className="btn-sty"
                >
                  Cancel
                </Button>
              </div>
            </form>
          </Box>
        </Modal>
      ) : (
        ""
      )}


{/* Add Email modal */}
    {openAddEmailModal === true ? (
        <Modal
          open={openAddEmailModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            ></Typography>
            <form onSubmit={handleSubmitEmail}>
              <TextField
                type="email"
                variant="outlined"
                color="secondary"
                label="Email"
                value={email}
                inputProps={{
                  type: "email",
                }}
                fullWidth
                required
                onChange={handleEmailChange}
                sx={{ mb: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
                error={!!emailError && email !== ''} // Sets the error state only if there's an error and the field is not empty
                helperText={emailError} // Displays the error message
              />
               {/* {emailError && (
                <Typography variant="body2" color="error">
                  {emailError}
                </Typography>
              )} */}
              <TextField
                    fullWidth
                    select
                    label="Select Send Type"
                    name="name"
                    onChange={handleSendTypeChange}
                    required
                    value={sendType}
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{ native: true }}
                    sx={{ mb: 2 }}
                  >
                    <option key="" value="" disabled>
                      {" "}
                      Please select{" "}
                    </option>
                    <option key="to" value="to">
                      To
                    </option>
                    <option key="bcc" value="bcc">
                      Bcc
                    </option>
                    <option key="cc" value="cc">
                      Cc
                    </option>
                 
                  </TextField>

              <div className="text-end mt-2">
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  className="me-4 btn-sty"
                >
                  Save
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleEmailModalCloses}
                  size="large"
                  className="btn-sty"
                >
                  Cancel
                </Button>
              </div>
            </form>
          </Box>
        </Modal>
      ) : (
        ""
      )}

      {/* Add email modal ends */}

      {/* Edit email modal */}

      {openEditEmailModal === true ? (
        <Modal
          open={openEditEmailModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            ></Typography>
            <form onSubmit={handleSubmitEditEmail}>
              <TextField
                type="email"
                variant="outlined"
                color="secondary"
                label="Email"
                value={email}
                inputProps={{
                  type: "email",
                }}
                fullWidth
                required
                onChange={handleEmailChange}
                sx={{ mb: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
                error={!!emailError && email !== ''} // Sets the error state only if there's an error and the field is not empty
                helperText={emailError} // Displays the error message
              />
              <TextField
                    fullWidth
                    select
                    label="Select Send Type"
                    name="name"
                    onChange={handleSendTypeChange}
                    required
                    value={sendType}
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{ native: true }}
                    sx={{ mb: 2 }}
                  >
                    <option key="" value="" disabled>
                      {" "}
                      Please select{" "}
                    </option>
                    <option key="to" value="to">
                      To
                    </option>
                    <option key="bcc" value="bcc">
                      Bcc
                    </option>
                    <option key="cc" value="cc">
                      Cc
                    </option>
                 
                  </TextField>

              <div className="text-end mt-2">
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  className="me-4 btn-sty"
                >
                  Update
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleEmailEditModalCloses}
                  size="large"
                  className="btn-sty"
                >
                  Cancel
                </Button>
              </div>
            </form>
          </Box>
        </Modal>
      ) : (
        ""
      )}

      {/* Edit email modal ends */}

{/* Delete Conformation modal */}
      {/* <Modal
            open={opendeleteConformation}
            title="Delete"
            onOk={(e) => {
              e.preventDefault(); 
              handleDeleteEmail(emailConfig.fid);
            }}
            onCancel={CloseDeleteConformation}
            footer={[
              <Button key="back" onClick={CloseDeleteConformation}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                // onClick={(e) => {
                //   e.preventDefault(); 
                //   handleDeleteEmail(emailConfig.fid);
                // }}
              >
                Delete
              </Button>
            ]}
          >
            <p className="text-center">
              Are you sure you want to Delete ?
            </p>
          </Modal> */}

        {/* <Modal
        open={opendeleteConformation}
        onClose={CloseDeleteConformation}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={conformation_modal_style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Delete
          </Typography>
          <p className="text-center mt-3 mb-3">
            Are you sure you want to delete?
          </p>
          <div className="text-end mt-2">
            <Button
              variant="text"
              onClick={() => {
                handleDeleteEmail(selectedEmailFid);
                CloseDeleteConformation(); 
              }}
            >
              Delete
            </Button>
            <Button
              variant="text"
              onClick={CloseDeleteConformation}
              className="ms-2"
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal> */}

      <AntdModal
            open={opendeleteConformation}
            title="Delete"
            // onOk={onConfirmButtonClick}
            onCancel={CloseDeleteConformation}
            footer={[
              <Button key="back" onClick={CloseDeleteConformation}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => {
                  handleDeleteEmail(selectedEmailFid);
                  CloseDeleteConformation(); 
                }}
              >
                Delete
              </Button>,
            ]}
          >
            <p className="text-center">Are you sure you want to Delete ?</p>
          </AntdModal>

         
  {/* Delete Conformation modal Ends*/}
  
  <AntdModal
            open={showcompanyDeleteModel}
            title="Delete"
            // onOk={onConfirmButtonClick}
            onCancel={handlecancelCompanyDelete}
            footer={[
              <Button key="back" onClick={handlecancelCompanyDelete}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => {
                  handleDeletecompany();
                  handlecancelCompanyDelete();
                  ; 
                }}
              >
                Delete
              </Button>,
            ]}
          >
            <p className="text-center">Are you sure you want to Delete Company ({selectedCompany_nameDelete} )?</p>
          </AntdModal>

  {/* Admin Delete Conformation */}

  <AntdModal
            open={opendeleteAdminConformation}
            title="Delete"
            // onOk={onConfirmButtonClick}
            onCancel={CloseAdminConformationDelete}
            footer={[
              <Button key="back" onClick={CloseAdminConformationDelete}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => {
                  handleDeleteAdmin(selectedAdmin_id);
                  CloseAdminConformationDelete(); 
                }}
              >
                Delete
              </Button>,
            ]}
          >
            <p className="text-center">Are you sure you want to Delete ?</p>
          </AntdModal>

  {/* Admin Delete Conformation Ends */}

    {/* Company Delete Conformation */}
{/* 
    <AntdModal
            open={opendeleteCompanyConformation}
            title="Delete"
            // onOk={onConfirmButtonClick}
            onCancel={CloseCompanyConformationDelete}
            footer={[
              <Button key="back" onClick={CloseCompanyConformationDelete}>
                Cancel
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => {
                  handleDeletecompany(selectedComapny_id);
                  CloseCompanyConformationDelete(); 
                }}
              >
                Delete
              </Button>,
            ]}
          >
            <p className="text-center">Are you sure you want to Delete ?</p>
          </AntdModal> */}

  {/* Company Delete Conformation Ends */}

      
      {/* <Navbar name="Dashboard" /> */}
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          {/* <DrawerHeader />
        <Typography paragraph>
        
        </Typography> */}
          <div className="App">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h3 className="heading-style">{/* Customer Detailsdg */}</h3>
            </div>
            <div className="form-style col-6 m-auto">
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="View Company" {...a11yProps(0)} />
                  <Tab label="View Admin" {...a11yProps(1)} />
                  <Tab label="View History" {...a11yProps(2)} />
                  <Tab label="Flash Email Configuration" {...a11yProps(3)} />

                </Tabs>
              </Box>

              {isLoading ? (
                <div
                  className="table-style"
                  style={{ marginLeft: '46%', marginTop: '20%' }}
                >
                  <PulseLoader
                    color="#02487B"
                    height={29}
                    margin={4}
                    radius={24}
                    width={4}
                  />
                  <p style={{ fontWeight: 'bold', color: '#02487B' }}>Loading</p>
                </div>
              ) : (
                <>

              <TabPanel value={value} index={0}>
                {/*  */}
                <Button
                            className="btn-sty text-capitalize status-icon mb-4 "
                            onClick={HandleClicks}
                            startIcon={
                              <SvgIcon fontSize="small">
                                <PlusIcon />
                              </SvgIcon>
                            }
                            variant="contained"
                          >
                            Create Company
                          </Button>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ color: "#1976d2" }}>
                          Company Name
                        </TableCell>
                        <TableCell sx={{ color: "#1976d2" }} align='center'>Edit</TableCell>
                        <TableCell sx={{ color: "#1976d2" }} align='center'> Delete</TableCell>
                       
                       
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {companyLists.map((row) => (
                        <TableRow
                          key={row}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {row.company_name}
                          </TableCell>
                          <TableCell component="th" scope="row" align='center'>
                            <div>
                              <a
                                href="#"
                                onClick={() => {
                                  handleEditcompany(row.company_id);
                                }}
                              >
                                {/* <EditIcon /> */}
                                <img src={editIcon} alt="edit" />
                              </a>
                            </div>
                          </TableCell>

                                 {/* // ------------------ */}
                          <TableCell component="th" scope="row" align='center'>
                            <div>
                              <a
                                href="#"
                                // onClick={() => {
                                //   handleDeletecompany(row.company_id);
                                // }}
                                onClick={() => {
                                  handleDeletecompanyClickPopup(row.company_id,row.company_name);
                                }}
                                className="text-danger"
                                
                                data-toggle="modal"
                              >
                                {/* <DeleteOutlineIcon /> */}
                                <img src={deleteIcon} alt="edit" />
                              </a>
                            </div>
                          </TableCell>
                                  {/* // ------------------ */}

                          
                          {/* <TableCell component="th"></TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* {companyList.map((company) => ( <option key={company} value={company}>{company}</option>))} */}
              </TabPanel>

              

              <TabPanel value={value} index={1}>
              <Button
                            className="btn-sty text-capitalize status-icon mb-4 "
                            onClick={HandleClick}
                            startIcon={
                              <SvgIcon fontSize="small">
                                <PlusIcon />
                              </SvgIcon>
                            }
                            variant="contained"
                          >
                            Create Admin
                          </Button>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ color: "#1976d2" }}>
                          Company Name
                        </TableCell>
                        <TableCell sx={{ color: "#1976d2" }}>
                          Admin Name
                        </TableCell>

                        <TableCell sx={{ color: "#1976d2" }}>
                          Email ID
                        </TableCell>
                        <TableCell sx={{ color: "#1976d2" }} align="center">Edit</TableCell>
                        <TableCell sx={{ color: "#1976d2" }} align="center">Delete</TableCell>
                        {/* <TableCell sx={{ color: "#1976d2" }}></TableCell> */}
                       
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {List.map((row) => (
                        <TableRow
                          key={row}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {row.company}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.first_name} {row.last_name}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.username}
                          </TableCell>
                          <TableCell component="th" scope="row" align="center">
                            <div>
                              <a
                                href="#"
                                onClick={() => {
                                  handleEdit(row.admin_id);
                                }}
                              >
                                {/* <EditIcon /> */}
                                <img src={editIcon} alt="edit" />
                              </a>
                            </div>
                          </TableCell>

                                  {/* // ------------------ */}
                          <TableCell component="th" scope="row" align="center">
                            <div>
                              <a
                                href="#"
                                // onClick={() => {
                                //   handleDeleteAdmin(row.admin_id);
                                // }}
                                onClick={()=>{
                                  OpenAdminConformationDelete(row.admin_id)
                                }}

                                className="text-danger"
                                
                                data-toggle="modal"
                              >
                                {/* <DeleteOutlineIcon /> */}
                                <img src={deleteIcon} alt="edit" />
                              </a>
                            </div>
                          </TableCell>
                                  {/* // ------------------ */}


                          {/* <TableCell component="th" scope="row"></TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/*  */}
              </TabPanel>


              {/* ------------------------------start */}

              <TabPanel value={value} index={2}>
             
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ color: "#1976d2" }}>
                          Admin 
                        </TableCell>
                        {/* <TableCell sx={{ color: "#1976d2" }}>
                          Company Name 
                        </TableCell> */}

                        <TableCell sx={{ color: "#1976d2" }}>
                          Success
                        </TableCell>
                        <TableCell sx={{ color: "#1976d2" }}>
                          Fail
                        </TableCell>
                        <TableCell sx={{ color: "#1976d2" }}>
                          Total
                        </TableCell>
                        <TableCell sx={{ color: "#1976d2" }}>
                          Date Modified
                        </TableCell>
                        <TableCell sx={{ color: "#1976d2" }}>Download Failed Csv</TableCell>
                        {/* <TableCell sx={{ color: "#1976d2" }}>Delete</TableCell> */}
                        {/* <TableCell sx={{ color: "#1976d2" }}>Delete</TableCell> */}
                        {/* <TableCell sx={{ color: "#1976d2" }}>
                         
                        </TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {historyList.map((row) => (
                        <TableRow
                          key={row}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                         
                          <TableCell component="th" scope="row">
                            {row.admin_name}
                          </TableCell>
                          {/* <TableCell component="th" scope="row">
                            {'company'}
                          </TableCell> */}
                          <TableCell component="th" scope="row">
                            {row.successful_records}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.failed_records}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.total_records}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            { /* {row.date_modified} */} 
                            {convert_to_localtime(row.date_modified)}
                          </TableCell>

                          <TableCell component="th" scope="row">
                            <div>
                              {/* <a
                                href="#"
                                onClick={() => {
                                  handleEdit(row.admin_id);
                                }}
                              >
                                <EditIcon />
                              </a> */}
                              <Button 
                              variant="text"
                              // style={{marginLeft:'33px'}}
                              className="btn-sty"
                              // onClick={handleDownloadClick}
                              onClick={() => {
                                handleDownloadClick(row.import_id);
                              }}
                              >
                                <img src={downloadIcon} alt="download" />
                                {/* Download <SvgIcon fontSize="small">
                                              <FileDownloadIcon/>
                                            </SvgIcon> */}
                                            
                                            </Button>
                            </div>
                          </TableCell>


                                  {/* // ------------------ */}
                          {/* <TableCell component="th" scope="row">
                            <div>
                              <a
                                href="#"
                                onClick={() => {
                                  handleDeleteAdmin(row.admin_id);
                                }}

                                className="text-danger"
                                
                                data-toggle="modal"
                              >
                                <DeleteOutlineIcon />
                              </a>
                            </div>
                          </TableCell> */}
                                  {/* // ------------------ */}


                          {/* <TableCell component="th" scope="row"></TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/*  */}
              </TabPanel>

              {/* ------------------------------end */}



              {/* ------------------------------start */}

              <TabPanel value={value} index={3}>

              <div className="d-flex justify-content-end align-items-center mb-4">

              <TextField
                select
                label="Select Sent Type"
                variant="outlined"
                value={selectedFilter}  // Controlled component
                onChange={handleFilterChange}  // Handle filter changes
                sx={{
                  minWidth: 220,
                  '& .MuiOutlinedInput-root': {
                    height: '43px',
                    borderRadius: '30px',
                    padding: '0 14px', 
                    '& .MuiSelect-select': {
                      padding: '10px 14px', 
                    },
                  },
                  '& .MuiInputLabel-root': {
                    lineHeight: 'normal', 
                  },
                }}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="to">to</MenuItem>
                  <MenuItem value="cc">cc</MenuItem>
                  <MenuItem value="bcc">bcc</MenuItem>
                  
              </TextField>

              <Button
                className="btn-sty text-capitalize status-icon ms-3"
                onClick={HandleAddEmailClick}
                startIcon={
                  <SvgIcon fontSize="small">
                    <PlusIcon />
                  </SvgIcon>
                }
                variant="contained"
              >
                Add Email
              </Button>

              </div>
             
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                      <TableRow>
                        <TableCell sx={{ color: "#1976d2" }}>
                          Email
                        </TableCell>
                        <TableCell sx={{ color: "#1976d2" }}>
                          Send Type
                        </TableCell>

                        
                        <TableCell sx={{ color: "#1976d2" }} align="center">Edit</TableCell>
                        <TableCell sx={{ color: "#1976d2" }} align="center">Delete</TableCell>
                        
                       
                      </TableRow>
                    </TableHead>
                    <TableBody>
                    {/* {emailLists.map((emailConfig, index) => ( */}
                    {emailDataForFiltering.map((emailConfig,index)=>(
                        <TableRow
                          key={emailConfig}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {emailConfig.email}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {emailConfig.sent_type}
                          </TableCell>
                          
                          <TableCell component="th" scope="row" align="center">
                            <div>
                              <a
                                href="#"
                                onClick={() => {
                                  handleEditEmail(emailConfig);
                                }}
                               
                              >
                                
                                <img src={editIcon} alt="edit" />
                              </a>
                            </div>
                          </TableCell>

                                 
                          <TableCell component="th" scope="row" align="center">
                            <div>
                              <a
                                href="#"
                                onClick={() => OpenConformationModal(emailConfig.fid)}
                                // onClick={(e) => {
                                //   e.preventDefault(); 
                                //   handleDeleteEmail(emailConfig.fid);
                                // }}
                                className="text-danger"
                                
                                data-toggle="modal"
                              >
                                
                                <img src={deleteIcon} alt="edit" />
                              </a>
                            </div>
                          </TableCell>
                                
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </TabPanel>
              </>
              )}

              {/* ------------------------------end */}
            




            </div>
          </div>
        </Box>
      </Box>
    </>
  );
}

export default UserForm;
